import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { PLATFORM_REPORT_ID } from './platformReportId';

const emptyColumns = [FIELDS.PLATFORM_CODE].map(createFooterMapper(PLATFORM_REPORT_ID));

const platformReportFooterColumnDefinition = [...emptyColumns];

export default platformReportFooterColumnDefinition;
